<wbo-edit-page #editPage [title]="model.data.account.details.accountName" (saving)="onSave($event)"
               [disableAction]="disableAction">
    <wbo-entity-actions>
        <wbo-entity-action *ngIf="appliedChargePayments.length != 0"
                           [title]="'wbo.account-payment.edit.actions.unapply'"
                           (click)="unapplyPayment()"></wbo-entity-action>
        <wbo-entity-action *ngIf="editMode" [title]="'wbo.account-payment.search.action.receipt'"
                           (click)="generateReceipt()"></wbo-entity-action>
    </wbo-entity-actions>

    <fui-formation-group-template
        *formationGroup="{title: 'wbo.account-payment.edit.formation.details', formControlNames: ['', 'details']}">

        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row formGroupName="details">
                <fui-two-columns>
                    <fui-column>
                        <wbo-currency-edit-control formControlName="paymentAmt"
                                                   [(ngModel)]="model.data.details.paymentAmt"
                                                   (valueChange)="amountUpdated()"
                                                   [readonly]="editMode"></wbo-currency-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-payment-details-single-select-edit-control formControlName="details"
                                                                        [(ngModel)]="model.data.details.details"
                                                                        [readonly]="editMode"></wbo-payment-details-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row formGroupName="details">
                <fui-two-columns>
                    <fui-column>
                        <wbo-outlet-single-select-edit-control formControlName="outletId"
                                                               [(ngModel)]="outlet.outletId"
                                                               [objectValue]="outlet"
                                                               *ngIf="!editMode"></wbo-outlet-single-select-edit-control>

                        <wbo-text-edit-control formControlName="outletId"
                                               [(ngModel)]="model.data.details.outletName"
                                               [readonly]="true"
                                               *ngIf="editMode"></wbo-text-edit-control>

                    </fui-column>
                    <fui-column>
                        <wbo-date-edit-control formControlName="paymentDate"
                                               [(ngModel)]="model.data.details.paymentDate"
                                               [readonly]="editMode"></wbo-date-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row *ngIf="!editMode || model.data.details.reference">
                <fui-two-columns>
                    <fui-column formGroupName="details">
                        <wbo-text-edit-control formControlName="reference"
                                               [(ngModel)]="model.data.details.reference"
                                               [readonly]="editMode"></wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>

            <fui-row [label]="'wbo.account-payment.edit.field-set.summary'">
                <fui-rows [formGroup]="editPage.formGroup">
                    <fui-row>
                        <fui-column>
                            <fui-inline-information
                                *ngIf="status === 'voided'"
                                [title]="'wbo.common.info.information'"
                                [message]="'wbo.account-payment.edit.message.voided'">
                            </fui-inline-information>
                            <fui-inline-information
                                *ngIf="type === 'void'"
                                [title]="'wbo.common.info.information'"
                                [message]="'wbo.account-payment.edit.message.void'">
                            </fui-inline-information>
                        </fui-column>
                    </fui-row>
                    <fui-row>
                        <fui-two-columns>
                            <fui-column>
                                <wbo-currency-edit-control label="wbo.account-payment.edit.field.totalCredit.label"
                                                           placeholder="wbo.account-payment.edit.field.totalCredit.placeholder"
                                                           [ngModelOptions]="{standalone: true}"
                                                           [(ngModel)]="totalCredit"
                                                           [readonly]="true"></wbo-currency-edit-control>
                            </fui-column>
                            <fui-column>
                                <wbo-percentage-edit-control *ngIf="editMode"
                                                             label="wbo.account-payment.edit.field.discount.label"
                                                             placeholder="wbo.account-payment.edit.field.discount.placeholder"
                                                             [ngModelOptions]="{standalone: true}"
                                                             [(ngModel)]="model.data.details.creditAmountDiscountPercent"
                                                             [readonly]="true"></wbo-percentage-edit-control>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                    <fui-row>
                        <fui-two-columns>
                            <fui-column>
                                <wbo-currency-edit-control label="wbo.account-payment.edit.field.totalApplied.label"
                                                           placeholder="wbo.account-payment.edit.field.totalApplied.placeholder"
                                                           [ngModelOptions]="{standalone: true}"
                                                           [(ngModel)]="totalApplied"
                                                           [readonly]="true"></wbo-currency-edit-control>
                            </fui-column>
                            <fui-column>
                                <wbo-currency-edit-control label="wbo.account-payment.edit.field.discrepancy.label"
                                                           placeholder="wbo.account-payment.edit.field.discrepancy.placeholder"
                                                           [ngModelOptions]="{standalone: true}"
                                                           [(ngModel)]="discrepancy"
                                                           [readonly]="true"></wbo-currency-edit-control>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                </fui-rows>
            </fui-row>

            <fui-row *ngIf="canApply && chargePayments.length != 0">
                <wbo-edit-grid [title]="'wbo.account-payment.edit.field.chargesOutstanding.label'"
                               [data]="chargePayments" [entityPath]="'chargePayments'" [editable]="true"
                               [removable]="false" [reorderable]="false" (saved)="chargeUpdated($event)">
                    <wbo-text-column field="charge.referenceNo"></wbo-text-column>
                    <wbo-date-column field="charge.chargeDate"></wbo-date-column>
                    <wbo-text-column field="charge.status"></wbo-text-column>
                    <wbo-currency-column field="charge.amtDue"></wbo-currency-column>
                    <wbo-currency-column field="amtUsed" [editable]="true"></wbo-currency-column>
                    <wbo-column [width]="30" [title]="'wbo.account-payment.edit.column.chargePayments.actions'">
                        <ng-template cellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                            <fui-action [attr.title]="'wbo.account-payment.edit.button.applyToCharge' | translate"
                                        (click)="applyPaymentToCharge(dataItem)">
                                <fui-icon [height]="20" [icon]="'coin-verified'" [width]="20"></fui-icon>
                            </fui-action>
                        </ng-template>
                    </wbo-column>

                </wbo-edit-grid>

            </fui-row>

            <fui-row *ngIf="appliedChargePayments.length != 0">
                <wbo-edit-grid [title]="'wbo.account-payment.edit.field.chargesApplied.label'"
                               [data]="appliedChargePayments" [entityPath]="'chargePayments'" [editable]="false"
                               [removable]="false" [reorderable]="false">
                    <wbo-text-column field="charge.referenceNo"></wbo-text-column>
                    <wbo-date-column field="charge.chargeDate"></wbo-date-column>
                    <wbo-text-column field="charge.status"></wbo-text-column>
                    <wbo-currency-column field="amtUsed"></wbo-currency-column>
                </wbo-edit-grid>

            </fui-row>

        </fui-rows>

    </fui-formation-group-template>
</wbo-edit-page>
